<template>
  <v-dialog
    v-model="show"
    max-width="440px"
    persistent
  >
    <v-card class="pa-sm-8 pa-4">
      <v-card-title class="text-h6 pa-0 mb-1">
        Смена пароля
      </v-card-title>
      <v-card-subtitle class="pa-0 mb-6">
        {{ userName }}
      </v-card-subtitle>

      <v-card-text
        v-if="!password"
        class="pa-0"
      >
        <p class="mb-0">
          Сотруднику будет выдан новый временный пароль. Старый перестанет работать сразу,
          поэтому новый нужно ему передать.
        </p>
      </v-card-text>

      <v-card-text
        v-else
        class="pa-0"
      >
        <v-text-field
          :value="password"
          readonly
          outlined
          dense
          hide-details
          label="Временный пароль"
          :append-icon="icons.mdiContentCopy"
          class="password-field"
          @click:append="copy"
        ></v-text-field>

        <v-alert
          dense
          text
          type="warning"
          class="mt-4 mb-0 text-sm"
        >
          Пароль показан один раз — в базе он хранится только хешем. Скопируйте его сейчас.
        </v-alert>

        <p class="text--secondary text-sm mt-4 mb-0">
          Сменить его на свой сотрудник сможет сам в «Настройках аккаунта».
        </p>
      </v-card-text>

      <v-card-actions class="pa-0 mt-6">
        <v-spacer></v-spacer>
        <template v-if="!password">
          <v-btn
            color="secondary"
            outlined
            @click="close"
          >
            Отмена
          </v-btn>
          <v-btn
            color="primary"
            :loading="resetting"
            @click="reset"
          >
            Выдать пароль
          </v-btn>
        </template>
        <v-btn
          v-else
          color="primary"
          @click="close"
        >
          Готово
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import { mdiContentCopy } from '@mdi/js'

export default {
  name: 'UserPasswordDialog',
  props: {
    show: { type: Boolean, default: false },
    userId: { type: Number, default: 0 },
    userName: { type: String, default: '' },
    cancellation: { type: Function, required: true },
  },
  data: () => ({
    icons: { mdiContentCopy },
    password: '',
    resetting: false,
  }),
  watch: {
    show(opened) {
      if (opened) this.password = ''
    },
  },
  methods: {
    ...mapActions('user', { resetPassword: 'resetPassword' }),
    ...mapActions('message', { success: 'success' }),
    async reset() {
      this.resetting = true
      try {
        this.password = await this.resetPassword(this.userId)
      } finally {
        this.resetting = false
      }
    },
    async copy() {
      try {
        await navigator.clipboard.writeText(this.password)
        await this.success('Пароль скопирован')
      } catch {
        await this.success('Скопируйте пароль из поля вручную')
      }
    },
    close() {
      this.password = ''
      this.cancellation()
    },
  },
}
</script>

<style lang="scss" scoped>
.password-field ::v-deep input {
  font-family: monospace;
  letter-spacing: 0.08em;
}
</style>
